import { Badge, BADGE_TYPE_INFO, BADGE_TYPE_NEUTRAL } from '@calendly/ui/components/badge'
import { Button } from '@calendly/ui/components/button'
import { BodyText } from '@calendly/ui/components/typography'

import { useSpotlightTourState } from 'hooks/useSpotlightTourState'

import { debugPanelActionsCss, debugPanelStatusCss } from './debugPanelStyles'
import { SPOTLIGHT_TOUR_DEBUG_CONFIG, type SpotlightTourDebugId } from './spotlightTourDebugConfig'

type Props = {
  tourId: SpotlightTourDebugId
}

/** Shared debug panel body for backend-persisted spotlight tours (title from registration). */
export const SpotlightTourDebugSection = ({ tourId }: Props) => {
  const config = SPOTLIGHT_TOUR_DEBUG_CONFIG[tourId]
  const { isDismissed, reset, dismiss } = useSpotlightTourState(
    config.spotlightKey,
    config.forceShowParam,
  )

  return (
    <>
      <div className={debugPanelStatusCss}>
        <Badge type={isDismissed ? BADGE_TYPE_NEUTRAL : BADGE_TYPE_INFO}>
          {isDismissed ? 'Dismissed' : 'Not dismissed'}
        </Badge>
      </div>
      <div className={debugPanelStatusCss}>
        <BodyText size="x-small">
          Resets state to re-run the tour.
          {' '}
          {config.reloadHint}
          {' '}
          Use ?
          {config.forceShowParam}
          =1 to force-show.
          {config.activeTourWarning ? ' Avoid using while a tour is active.' : ''}
        </BodyText>
      </div>
      <div className={debugPanelActionsCss}>
        {config.actions.includes('reset') && (
          <Button
            size="small"
            decoration="secondary-outline"
            onClick={reset}
            data-testid={config.resetTestId}
          >
            {config.resetLabel ?? 'Reset tour'}
          </Button>
        )}
        {config.actions.includes('dismiss') && config.dismissTestId && (
          <Button
            size="small"
            decoration="secondary-outline"
            onClick={dismiss}
            data-testid={config.dismissTestId}
          >
            Dismiss tour
          </Button>
        )}
      </div>
    </>
  )
}
